import Vue from 'vue'
import wx from 'weixin-js-sdk'
import apis from '@/api'
import {getCookie, setCookie} from '@/utils/auth'
import { Dialog } from 'vant';
import router from "@/router";
import API from '@/api'
Vue.use(Dialog);

// 初始化微信sdk方法
export const wxJsSdkInit = function () {
    let url = '';
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
        url = getCookie('main_url')
        setCookie('main_url', '')
    } else {
        url = window.location.href;
    }

    // 检查用户是否有地址（外卖）
    let coType = getCookie('coType')
    if (coType === '2') {
        API.getUserAddress().then(res => {
            if (res.data.data.length > 0) {
                router.push('/userAddress')
                return true;
            }
        })
    }

    // 微信获取地理位置接口
    apis.getJSSDK({type: 1, url: url}) // 调用接口
        .then(
            (resp) => {
                setTimeout(()=> {
                    // 成功返回
                    wx.config(resp.data.data)
                    wx.error(() => {
                        // 微信配置失败
                        // console.log(res)
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    })
                    wx.ready(() => {
                        wx.getLocation({
                            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                            success: (res) => {
                                var lat = res.latitude // 纬度，浮点数，范围为90 ~ -90
                                var lng = res.longitude // 经度，浮点数，范围为180 ~ -180。
                                // var speed = res.speed // 速度，以米/每秒计
                                // var accuracy = res.accuracy // 位置精度
                                apis.sendLatLng({
                                    lat: lat,
                                    lng: lng
                                }).then(res => {
                                    if (resp.data.data.debug) {
                                        Dialog.alert({
                                            message: '微信定位成功：' + JSON.stringify(res),
                                        })
                                    }
                                    setCookie('lat', lat)
                                    setCookie('lng', lng)
                                    setCookie('address', res.data.data)
                                    setCookie('key_check', 1)
                                    if (coType === '2') {
                                        router.push('/userAddress')
                                    } else {
                                        router.push('/address')
                                    }
                                })
                            },
                            fail: () => {
                                // Dialog.alert({
                                //     message: '微信定位失败，请稍后重试' + JSON.stringify(err),
                                // })
                                setCookie('key_check', 0)
                                let coType = getCookie('coType')
                                if (coType === '2') {
                                    router.push('/userAddress')
                                } else {
                                    router.push('/address')
                                }
                            },
                            cancel: () => {
                                // Dialog.alert({
                                //     message: '微信定位未授权，请稍后重试',
                                // })
                                setCookie('key_check', 0)
                                if (coType === '2') {
                                    router.push('/userAddress')
                                } else {
                                    router.push('/address')
                                }
                            }
                        })
                        // 微信配置成功
                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                        // console.log(res)
                    })
                }, 100);
            },
            (err) => {
                console.error(err)
            }
        )
        .catch((err) => {
            console.error(err)
        })
}

export default {
    wxJsSdkInit
}
